import STRINGS from '@/constants/strings'

import Picture from '../picture'

interface AppItem {
  icon: string
  alt: string
  appName: string
  appLink: string
}

interface Props {
  apps: AppItem[]
}

const DownloadApp = ({ icon, alt, appName, appLink }: AppItem) => (
  <a
    href={appLink}
    rel="noopener noreferrer"
    target="_blank"
    className="text-base leading-[1.42] pt-2.5 hover:text-[#6ab41f] transition-all duration-300 flex-1 flex items-center"
  >
    <span className="px-4">
      <Picture image={icon} imageAlt={alt} imageStyle="w-10 h-10" />
    </span>
    <span>
      <span className="block">{STRINGS.COMMON.DOWNLOAD}</span>
      <span className="block mt-1">{appName}</span>
    </span>
  </a>
)

const DownloadApps = ({ apps }: Props) => (
  <section className="flex flex-wrap md:flex-row flex-col">
    <p className="text-lg pr-8 md:w-1/4 pt-2.5 mb-2.5">
      {STRINGS.COMMON.DIRECTLY_DOWNLOAD_APP}
    </p>
    <div className="flex-1 flex flex-wrap md:flex-row flex-col">
      {apps.map((app) => (
        <DownloadApp key={app.appLink} {...app} />
      ))}
    </div>
  </section>
)

export default DownloadApps
